import * as React from 'react';

import ContentPlaceholder from 'basics/loaders/ContentPlaceholder/ContentPlaceholder';
import { Bar, SkeletonStack } from 'basics/loaders/ContentPlaceholder/ContentPlaceholder.styled';

import { PoolIdentityLoading } from './MyLiquidity.styled';
import {
    LoadingHead,
    LoadingRow,
    LoadingValue,
    LoadingActions,
    LoadingLogos,
} from './MyLiquidityLoading.styled';

import RewardsBannerLoading from '../RewardsBanner/RewardsBannerLoading';

const MyLiquidityLoading = () => (
    <ContentPlaceholder label="Loading your liquidity positions">
        <RewardsBannerLoading />
        <div aria-hidden="true">
            <LoadingHead>
                <span>Pool</span>
                <span>Pooled</span>
                <span>Daily Rewards</span>
                <span>Ready To Claim</span>
                <span>Total APR</span>
                <span />
            </LoadingHead>
            <LoadingRow>
                <PoolIdentityLoading>
                    <LoadingLogos>
                        <Bar $width="3.2rem" $height="3.2rem" $circle />
                        <Bar $width="3.2rem" $height="3.2rem" $circle />
                    </LoadingLogos>
                    <SkeletonStack $gap="0.8rem">
                        <Bar $width="12rem" $height="2rem" />
                        <Bar $width="7rem" $height="1.6rem" />
                        <Bar $width="16rem" />
                    </SkeletonStack>
                </PoolIdentityLoading>
                {['Pooled', 'Daily Rewards', 'Ready To Claim', 'Total APR'].map(label => (
                    <LoadingValue key={label}>
                        <span>{label}</span>
                        <Bar $width="7rem" $height="2.4rem" />
                    </LoadingValue>
                ))}
                <LoadingActions>
                    <Bar $width="4.8rem" $height="4.8rem" />
                    <Bar $width="4.8rem" $height="4.8rem" />
                </LoadingActions>
            </LoadingRow>
        </div>
    </ContentPlaceholder>
);
export default MyLiquidityLoading;
